import { render, staticRenderFns } from "./couponCard.vue?vue&type=template&id=1caa1732&scoped=true"
import script from "./couponCard.vue?vue&type=script&lang=js"
export * from "./couponCard.vue?vue&type=script&lang=js"
import style0 from "./couponCard.vue?vue&type=style&index=0&id=1caa1732&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caa1732",
  null
  
)

export default component.exports